const hypothenuse = (a, b) => Math.sqrt(a * a + b * b);

export default hypothenuse;
